import React, { useState } from 'react'
import './RecuperarSenhaForm.css';
import Swal from 'sweetalert2'

function getCookie(nome) {
    var nomeEQ = nome + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)===' ') c = c.substring(1,c.length);
      if (c.indexOf(nomeEQ) === 0) return c.substring(nomeEQ.length,c.length);
    }
    return null;
}

function RecuperarSenhaForm ({ onCancel }) {

  const [email, setEmail] = useState('')

  const enviar_email_recuperar_senha = (evento) => {

    evento.preventDefault()

    Swal.fire({
      html: 'Enviando solicitação...',
      imageUrl: 'ufo.gif',
      imageWidth: 100,
      imageHeight: 100,
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    })

    // Adicionar lógica para enviar a solicitação de redefinição de senha
    fetch(`${process.env.REACT_APP_API_URL}/api/autenticacoes/enviar_email`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email })
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.status === 'erro') {
          Swal.fire({
            text: result.mensagem,
            icon: 'error',
          })
          setEmail("");
        } else {
          Swal.fire({
            title: 'Solicitação enviada!',
            text: 'Por favor, verifique seu e-mail para redefinir sua senha.',
            icon: 'success'
          })
          .then(() => {      
            window.location.reload();
          });
        }
      })
      .catch((error) => {
        console.log(error)
        Swal.fire({
          title: 'Ops!',
          text: 'Houve um problema ao tentar enviar a solicitação. Tente novamente mais tarde.',
          icon: 'info',
        })
      })
  }

  const detectar_tecla_enter = (evento) => {
    if (evento.key === 'Enter') {
      enviar_email_recuperar_senha(evento); // Chama a função ao pressionar Enter
    }
  };

  return (
    <div className='forgot-key'>
      <img src="lockus-icon.svg" className="logo"/>
      <h1>Esqueceu sua senha?</h1>
      <h4>Digite seu e-mail para alterar sua senha</h4>
      <div className="input-box">
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => {
            if (e.target.value.length <= 40) {
              setEmail(e.target.value);
            } else {
              Swal.fire({
                title: "Limite atingido!",
                text: "O email não pode ultrapassar 40 caracteres.",
                icon: "warning",
                timer: 2000,
                showConfirmButton: false,
              });
            }
          }}
          onKeyDown={detectar_tecla_enter}
          required
          maxLength={40}
        />
      </div>
      <button-container>
        <button onClick={enviar_email_recuperar_senha}>Enviar</button>
        <button onClick={onCancel} className="button-cancel">Cancelar</button>
      </button-container>
      
    </div>
  )
}

export default RecuperarSenhaForm
